export enum WeightUnitsEnum {
    Gram,
    Oz,
}
